import * as React from 'react';
export const IcColourSpot = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M10.23 20A8 8 0 017 18.48a1 1 0 00-1.24 1.57 10 10 0 004 1.93L10 22a1 1 0 001-.78 1 1 0 00-.77-1.22zM4 12.24a1 1 0 10-2 0 9.86 9.86 0 001 4.34 1 1 0 001.8-.87 7.88 7.88 0 01-.8-3.47zm-.55-3c.136.059.282.09.43.09a1 1 0 00.9-.56A8 8 0 017 6a1 1 0 00-1.25-1.56A10 10 0 003 7.9a1 1 0 00.45 1.34zm15.76 6.45a1 1 0 00.47 1.31c.135.062.282.096.43.1a1 1 0 00.9-.57 9.76 9.76 0 00.78-2.34h-2.05a7.833 7.833 0 01-.53 1.5zM17 18.47A8 8 0 0113.79 20a1.005 1.005 0 00.21 2c.073.01.147.01.22 0a10 10 0 004-1.93 1.006 1.006 0 10-1.22-1.6zm-7-14h.23A7.71 7.71 0 0112 4.22v-2a10 10 0 00-2.25.26 1.006 1.006 0 00.22 2l.03-.01zm8.34 6.67a1.82 1.82 0 002.59 0l.24-.24a1.84 1.84 0 000-2.59l-.8-.79 1-1a2.09 2.09 0 00.29-2.65 2 2 0 00-3-.25l-1.14 1.05-.8-.79a1.81 1.81 0 00-2.58 0l-.24.24a1.82 1.82 0 000 2.59l-4.59 4.58A1 1 0 009 12v3a1 1 0 001 1h3a1 1 0 00.7-.29l4.64-4.57zM12.43 11l2.88-2.88 1.59 1.59L15.6 11h-3.17z'
      fill='currentColor'
    />
  </svg>
);
